import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  Label,
  FormFeedback,
  Input,
} from "reactstrap";
import Loader from "./Loader";
import { Link } from "react-router-dom";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Flatpickr from "react-flatpickr";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosConfig";

function DocumentsPersonnelle({ onReload, user_id, accessor, data }) {
  const [modal, setModal] = useState(false);
  const [modalUpdateDate, setModalUpdateDate] = useState(false);

  const [selectedFile, setSelectedFile] = useState({});

  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedPathName, setSelectedPathName] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const toggleModal = () => {
    setModal(!modal);
    // if (!modal) {
    //   setSelectedImage(null);
    //   setSelectedImageName(null);
    // }
  };
  const handleSelect = (name, path, expir) => {
    const params = {
      user_id: user_id,
      name: name,
      path: path,
      expir: expir,
    };
    console.log("Params: ", params);

    setSelectedFile(params);
  };

  const toggleModalUpdatingDate = () => {
    setModalUpdateDate(!modalUpdateDate);
    if (!modalUpdateDate) {
      setSelectedPathName(null);
      setSelectedDate(new Date());
      setSelectedId(null);
      setSelectedImageName(null);
    }
  };

  const downloadImage = (url, filename) => {
    // console.log("filename: ", filename);
    // console.log("url: ", url);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });
    return dateObject;
  }

  // Filtrer et trier les documents
  const sortedAccessor = accessor.sort((a, b) => {
    const hasPathA = !!data[a.path];
    const hasPathB = !!data[b.path];
    return hasPathB - hasPathA;
  });

  const validationUpdateDate = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      date_expir: selectedFile.expir
        ? new Date(selectedFile.expir).toISOString().split("T")[0]
        : new Date().toISOString().split("T")[0],
      // date_expir: "18/07/2024",
    },
    validationSchema: Yup.object({
      date_expir: Yup.date()
        .required("Veuillez sélectionner la date d'expiration")
        .min(
          new Date(),
          "La date d'expiration doit être ultérieure à aujourd'hui"
        ),
    }),
    onSubmit: (values) => {
      // console.log("selectedFile: ", selectedFile);
      const dataBody = {
        piece: selectedFile.path,
        newdate: values.date_expir,
      };

      // console.log("dataBody: ", dataBody);
      try {
        const data = axiosInstance
          .put(
            `/updatedateexpirationpiece/?user_id=${selectedFile.user_id}/`,
            dataBody
          )
          .then((response) => {
            // dispatch(onUpdateChauffeur(updateChauffeur));
            validationUpdateDate.resetForm();
            toast.success(
              `Date d'expiration de "${selectedFile.name}" modifié avec succès`,
              {
                autoClose: 3000,
              }
            );
            onReload();
            setSelectedFile({});
          })
          .catch((error) => {
            toast.error(
              `Echec de la modification de la date d'expiration de "${selectedFile.name}"`,
              {
                autoClose: 3000,
              }
            );
          });

        // window.location.reload(true);
      } catch (err) {
        console.log(err);
        toast.error(
          `Echec de la modification de la date d'expiration de "${selectedFile.name}"`,
          {
            autoClose: 2000,
          }
        );
      }
      // console.log("dataBody: ", dataBody);
      // console.log("User Id: ", selectedId);

      toggleModalUpdatingDate();
    },
  });

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="d-flex align-items-center mb-4">
            <h5 className="card-title flex-grow-1 mb-0">Documents</h5>
          </div>

          <div className="table-responsive">
            {data && Object.keys(data).length !== 0 ? (
              <>
                <Table className="table-borderless align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th scope="col">Fichiers</th>
                      <th scope="col">Date d'expiration</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedAccessor.length > 0 &&
                      sortedAccessor.map((doc, key) => {
                        return data[doc.path] ? (
                          <tr key={key}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm">
                                  <div
                                    className={`avatar-title bg-soft-primary text-primary rounded fs-20`}
                                  >
                                    <i className="ri-image-2-fill"></i>
                                  </div>
                                </div>
                                <div className="ms-3 flex-grow-1">
                                  <h6 className="fs-15 mb-0">
                                    <Link to="#">{doc.name}</Link>
                                  </h6>
                                </div>
                              </div>
                            </td>
                            <td>
                              {doc.exp && data[doc.exp]
                                ? formatDate(data[doc.exp])
                                : "Pas de date"}
                            </td>
                            <td>
                              <UncontrolledDropdown direction="start">
                                <DropdownToggle
                                  tag="a"
                                  className="btn btn-light btn-icon"
                                  id={`dropdownMenuLink${key}`}
                                  role="button"
                                >
                                  <i className="ri-equalizer-fill"></i>
                                </DropdownToggle>
                                <DropdownMenu>
                                  {doc.exp && (
                                    <DropdownItem
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleSelect(
                                          doc.name,
                                          doc.path,
                                          data[doc.exp]
                                        );
                                        toggleModalUpdatingDate();
                                      }}
                                    >
                                      <i className="ri-pencil-fill me-2 align-middle text-muted" />
                                      Modifier l'expiration
                                    </DropdownItem>
                                  )}
                                  <DropdownItem
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setSelectedImageName(doc.name);
                                      setSelectedImage(
                                        `${doc.path}/${data[doc.path]}`
                                      );
                                      // console.log(
                                      //   `Visualiser: ${doc.path}/${
                                      //     data[doc.path]
                                      //   }`
                                      // );
                                      toggleModal();
                                    }}
                                  >
                                    <i className="ri-eye-fill me-2 align-middle text-muted" />
                                    Visualiser
                                  </DropdownItem>
                                  {/* <DropdownItem
                                    onClick={(e) => {
                                      e.preventDefault();
                                      const link = document.createElement("a");
                                      link.href = `${process.env.REACT_APP_API_URL}/${
                                        doc.path
                                      }/${data[doc.path]}`;
                                      link.download = doc.name;
                                      document.body.appendChild(link);
                                      link.click();
                                      document.body.removeChild(link);
                                    }}
                                  >
                                    <i className="ri-download-2-fill me-2 align-middle text-muted" />
                                    Télécharger
                                  </DropdownItem> */}
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        ) : (
                          <tr key={key}>
                            <td
                              colSpan="3"
                              className="text-center text-danger"
                            >{`Pas de ${doc.name.toLowerCase()}`}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </>
            ) : (
              <>
                <div className="text-center my-3">
                  <Loader style={{ color: "#014c94" }} />
                </div>
              </>
            )}
          </div>
        </CardBody>
      </Card>

      <Modal isOpen={modalUpdateDate} toggle={toggleModalUpdatingDate}>
        <ModalHeader toggle={toggleModalUpdatingDate}>
          Modifier la date d'expiration {selectedFile.name && selectedFile.name}
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validationUpdateDate.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Row>
              {/* Date expiration Pièce d'identité */}
              <Col lg={12}>
                <div>
                  <Label className="form-label" htmlFor="date_expir">
                    {`Date d'expiration ${
                      selectedFile.name && selectedFile.name
                    } `}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Label>

                  <Input
                    id="date_expir"
                    name="date_expir"
                    type="date"
                    onChange={validationUpdateDate.handleChange}
                    onBlur={validationUpdateDate.handleBlur}
                    value={validationUpdateDate.values.date_expir}
                    invalid={
                      validationUpdateDate.touched.date_expir &&
                      Boolean(validationUpdateDate.errors.date_expir)
                    }
                    min={new Date().toISOString().split("T")[0]}
                  />

                  {validationUpdateDate.touched.date_expir &&
                  validationUpdateDate.errors.date_expir ? (
                    <FormFeedback type="invalid">
                      {validationUpdateDate.errors.date_expir}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              style={{
                background: "#BED6E3",
                color: "#002437",
                border: " 1px solid #002437",
              }}
              onClick={toggleModalUpdatingDate}
            >
              Fermer
            </Button>
            <Button
              className="btn"
              type="submit"
              style={{ background: "#002437", color: "white" }}
              // onClick={toggleModalUpdatingDate}
            >
              Soumettre
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Visualiser le document</ModalHeader>
        <ModalBody>
          {selectedImage ? (
            (() => {
              const fileExtension = selectedImage
                .split(".")
                .pop()
                .toLowerCase();

              // Liste des extensions
              const imageExtensions = ["jpg", "jpeg", "png", "gif"];
              const videoExtensions = ["mp4", "webm", "ogg"];
              const pdfExtensions = ["pdf"];

              if (imageExtensions.includes(fileExtension)) {
                // Affichage d'image
                return (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${selectedImage}`}
                    alt={selectedImageName}
                    className="img-fluid"
                  />
                );
              } else if (videoExtensions.includes(fileExtension)) {
                // Affichage de vidéo
                return (
                  <video controls className="img-fluid">
                    <source
                      src={`${process.env.REACT_APP_API_URL}/${selectedImage}`}
                      type={`video/${fileExtension}`}
                    />
                    Votre navigateur ne supporte pas la lecture de cette vidéo.
                  </video>
                );
              } else if (pdfExtensions.includes(fileExtension)) {
                // Affichage de PDF
                return (
                  <iframe
                    src={`${process.env.REACT_APP_API_URL}/${selectedImage}`}
                    title={selectedImageName}
                    className="w-100"
                    style={{ height: "500px", border: "none" }}
                  />
                );
              } else {
                // Autre type de fichier
                return (
                  <div className="text-center">
                    Format non pris en charge pour la prévisualisation
                  </div>
                );
              }
            })()
          ) : (
            <div className="text-center">
              Pas de prévisualisation à afficher
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            style={{
              background: "#BED6E3",
              color: "#002437",
              border: " 1px solid #002437",
            }}
            onClick={toggleModal}
          >
            Fermer
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
}

export default DocumentsPersonnelle;
